module.exports = __webpack_public_path__ + "img/highlight-3-m.e2376afc.png";